<div class="card-desktop">
	<div class="card-row">
		<div
			*ngFor="let card of trustedCards"
			cols="12"
			md="4"
			class="card-col"
		>
			<a [href]="card.btn_url" target="_blank">
				<img
					class="card-image"
					[src]="card.thumbnail.url"
					:lazy-src="card.thumbnail.thumb_url"
					[alt]="card.thumbnail.custom_properties.alt_text"
					[height]="card.thumbnail.height"
					[width]="card.thumbnail.width"
				>
			</a>
			<p class="dark-navy card-desc" [innerHTML]="card.trustedDesc"></p>
			<a
				class="card-button"
				[href]="card.btn_url"
				target="_blank"
				[style.background-color]="card.btn_color ? card.btn_color : 'initial'"
				[style.color]="card.txt_color"
				[class.small]="card.btn_size === 'small'"
				[class.large]="card.btn_size === 'large'"
				[class.medium]="card.btn_size === 'medium'"
				[class.x-large]="card.btn_size === 'extra_large'"
				[class.x-small]="card.btn_size === 'extra_small'"
			>
				{{ card.btn_txt }}
			</a>
		</div>
	</div>
</div>